import { useNavigate } from '@/composables/useNavigate'
import { useRouter } from 'vue-router'
import { getNextOnboardingStep } from '@/features/onboarding/model/flow'

export function useOnboardingNavigation() {
  const router = useRouter()
  const { navigateTo } = useNavigate()

  function goToNextStep(answers: Array<{ questionKey: string }> | undefined): boolean {
    const next = getNextOnboardingStep(answers)
    if (!next) return false
    navigateTo(next.routePath)
    return true
  }

  function replaceWithNextStep(answers: Array<{ questionKey: string }> | undefined) {
    const next = getNextOnboardingStep(answers)
    if (!next) return null
    return { path: next.routePath, replace: true as const }
  }

  function reloadCurrentRoute() {
    void router.replace(router.currentRoute.value.fullPath)
  }

  return {
    goToNextStep,
    replaceWithNextStep,
    reloadCurrentRoute,
  }
}
